import React from 'react';
import Input from 'components/forms/Input/Input';
import 'components/AssumptionsDrawer/assumptions-drawer.scss';
import useAssumptions from 'views/Sources/hooks/useAssumptions';
import { useRootState } from 'store/StateProvider';
import { WorkloadTypesEnum } from 'types';

const DedupeTable = () => {
    const assumptions = useAssumptions();
    const {
        auth: { isDellUser: isDell },
    } = useRootState();

    return (
        <table className="dedup-table">
            <thead>
                <tr>
                    <th>Data Types and Dedup Ratio</th>
                    <th> </th>
                    <th>Dedup(X)</th>
                </tr>
            </thead>
            <tbody>
                {assumptions.dedupe.data.map((row) => (
                    <tr key={row.workloadType}>
                        <td>{row.dataTypesAndDedupeRatio}</td>
                        <td className="qa-label-container">{row.workloadTypeLabel}</td>
                        <td className="table-cell-editable qa-value-container">
                            <Input
                                type="number"
                                name={`dedupe.${row.key}`}
                                defaultValue={assumptions.dedupe[row.key]}
                            />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default React.memo(DedupeTable);
